import {
  FeeDistributionDebitSettings,
  FeeDistributionPaymentFileResponse,
  FeeDistributionRecord,
  FeeDistributionResponse,
  FeeDistributionSearchFilter,
} from 'src/modules/invoice/models/feeDistribution';
import AxiosInstance from './axios/interceptor';

const controller = 'FeeDistribution';

export const getFeeDistribution = (options: FeeDistributionSearchFilter) => {
  return AxiosInstance.get<FeeDistributionResponse>(controller, { params: options });
};

export const getFeeDistributionRecords = (ownerId: number) => {
  return AxiosInstance.get<FeeDistributionRecord[]>(`${controller}/Records`, { params: { ownerId } });
};

export const getFeeDistributionRecord = (id: number) => {
  return AxiosInstance.get<FeeDistributionRecord>(`${controller}/Records/${id}`);
};

export const createFeeDistributionRecord = (options: FeeDistributionSearchFilter) => {
  return AxiosInstance.post<FeeDistributionRecord>(`${controller}/Records`, null, { params: options });
};

export const deleteFeeDistributionRecord = (id: number) => {
  return AxiosInstance.delete(`${controller}/Records/${id}`);
};

export const createFeeDistributionPaymentFile = (id: number, payDate: string, statementText?: string) => {
  return AxiosInstance.post<FeeDistributionPaymentFileResponse>(`${controller}/Records/${id}/PaymentFile`, null, {
    params: { payDate, statementText },
  });
};

export const downloadFeeDistributionExcel = (id: number) => {
  return AxiosInstance.get(`${controller}/Records/${id}/Excel`, { responseType: 'blob' });
};

export const getFeeDistributionDebitSettings = () => {
  return AxiosInstance.get<FeeDistributionDebitSettings>(`${controller}/DebitSettings`);
};

export const saveFeeDistributionDebitSettings = (settings: FeeDistributionDebitSettings) => {
  return AxiosInstance.put<FeeDistributionDebitSettings>(`${controller}/DebitSettings`, settings);
};
